/*
 * @Author: cc
 * @Date: 2020-04-27 14:34:18
 * @LastEditTime: 2021-12-03 17:18:38
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\components\service\toolService.js
 * @Description: 公用工具方法（不属于各模块，解决一些小问题的方法集合）
 */
angular.module('components.service').factory('publicToolService', [
    '$templateRequest',
    '$rootScope',
    '$compile',
    '$timeout',
    '$controller',
    '$q',
    '$modal',
    '$state',
    'editingMediatype',
    '$injector',
    'localStorageService',
    'configuration',
    'messagePublishService',
    '$sessionStorage',
    function ($templateRequest, $rootScope, $compile, $timeout, $controller, $q, $modal, $state, editingMediatype, $injector, localStorageService, configuration, messagePublishService, $sessionStorage) {
        let trsHttpService = $injector.get('trsHttpService');
        let loginService = $injector.get('loginService');
        let globleParamsSet = $injector.get('globleParamsSet');

        /**
         * [getWindowTemplate description]获得模板
         *
         * @param   {[type]}  tepurl  [tepurl description]
         *
         * @return  {[type]}          [return description]
         */
        function getWindowTemplate(tepurl) {
            let deffer = $q.defer();
            $templateRequest(tepurl).then((template) => {
                deffer.resolve(template);
            });
            return deffer.promise;
        }

        /**
         * [compileTemplate description] 编译模板
         * @param  {[type]} template [description] 模板字符串
         * @param  {[object]} noticeInfo [description] 提醒内容
         * @return {[type]}          [description]
         */
        function compileTemplate(template, noticeInfo) {
            noticeInfo = angular.isObject(noticeInfo) ? noticeInfo : {};
            let $template = $(template);
            var controller = {};
            controller.$scope = $rootScope.$new();
            controller.$element = $template;
            controller.noticeInfo = noticeInfo;
            noticeInfo.close = function () {
                controller.$element.remove();
                controller.$scope.$destroy();
            };
            $template = $compile($template)(controller.$scope);
            $('body').append($template);
            $timeout(() => {
                let number = Math.floor((window.innerHeight - 60) / 120);
                $rootScope.$broadcast('newWindow', {
                    number: number,
                });
                $controller('noticeWindowCtrl', controller);
            });
        }

        /**
         * [getModeConfig description] 获取模块配置
         * @param   {[string]}  key     [key description] 模块名称
         * @return  {[promise]}         [return description]promise对象
         */
        function getModeConfig(key) {
            let defer = $q.defer();
            loginService.getCurrLoginUser().then((userInfo) => {
                globleParamsSet.getTokenService(userInfo.TENANTID).then((token) => {
                    trsHttpService.httpServer('/api/tenantcenter/funcionConfig/getFunctionByFunctionName', {
                        keyWord: key,
                    }, 'get', '',
                    {
                        token: token.token
                    }).then((data) => {
                        let obj = {};
                        data.datas.map((item) => {
                            if (item.configvalue) {
                                item.configvalue.map((config) => {
                                    angular.extend(obj, config);
                                });
                            }
                        });
                        defer.resolve({
                            config: obj,
                            token: token.token
                        });
                    }, (error) => {
                        defer.reject(error);
                    });
                });
            });
            return defer.promise;
        }
        return {

            /**
             * [createWindow description]创建一个小窗口
             * @param   {[type]}  tepurl  [data description]
             * @param   {[type]}  data  [data description]
             * @param   {[type]}  type  [data description]类型用于是否使用默认属性
             * @return  {[type]}        [return description]
             */
            createWindow: function (tepurl, data, type) {
                if (!angular.isObject(data)) {
                    return;
                }
                var mydata = {
                    title: '消息提醒',
                    doctitle: data.MESSAGE,
                    button: data.URL,
                };
                if (type === false) {
                    mydata = data;
                }
                getWindowTemplate(tepurl).then((template) => {
                    compileTemplate(
                        template,
                        mydata
                        // {
                        //     title: '消息提醒',
                        //     doctitle: data.MESSAGE,
                        //     button: data.URL,
                        // }
                    );
                });
            },

            /**
             * [mediaSelector 素材库图片和视频选择器]
             *
             * @param   {[type]}  options  [isMultiple 是否多选，true-多选；false-单选]
             *  @param   {[type]}  params [传的参数]
             *  @param   {[type]}  requestUrl [传的参数]请求的地址
             *options:{
             *   windowTitle:左上角的名称
             *   isMultiple：默认false，单选。 true多选
             *   itemDatas：需要传入的对象
             *   }
             * @return  {[type]}              [return description]
             */
            pictureSelector: function (options, params) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './components/service/pictureSelector/pictureSelector.html',
                    windowClass: 'mediaSelector',
                    backdrop: false,
                    resolve: {
                        options: function () {
                            return options;
                        },
                        params: function () {
                            return params;
                        },
                    },
                    controller: 'pictureSelectorCtrl',
                });
                modalInstance.result.then(function (result) {
                    deffer.resolve(result);
                });
                return deffer.promise;
            },

            /**
             * [downloadIamge description] 下载图片（主要针对网络地址）
             * @param   {[string]}  imgsrc  [imgsrc description] 图片地址
             * @param   {[string]}  name    [name description] 图片名称
             * @return  {undefined}         [return description]
             */
            downloadIamge: function (imgsrc, name) {
                let image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute('crossOrigin', 'anonymous');
                image.onload = function () {
                    let canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    let context = canvas.getContext('2d');
                    context.drawImage(image, 0, 0, image.width, image.height);
                    let url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
                    let a = document.createElement('a'); // 生成一个a元素
                    let event = new MouseEvent('click'); // 创建一个单击事件
                    a.download = name || 'photo'; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = imgsrc;
            },

            /**
             * [getNewmediaTypeAndProductId description]在编辑页中 通过url来返回新媒体渠道的产品id和mediatype值
             *
             * @return  {[type]}  [return description]
             */
            getNewmediaTypeAndProductId: function () {
                var needValue = {};
                // 定义匹配规则
                const stateParams = [
                    {
                        p: 'wxchannelid', // 微信
                        t: 'weixin', // 类型 为微信
                    },
                    {
                        p: 'wbchannelid',
                        t: 'weibo',
                    },
                    {
                        p: 'baijiahaoaccount',
                        t: 'baijiahao',
                    },
                    {
                        p: 'qiehaoaccount',
                        t: 'qiehao',
                    },
                    {
                        p: 'account',
                        t: 'toutiaohao',
                    },
                ];
                angular.forEach(stateParams, function (value, key) {
                    if (!!$state.params[value.p]) {
                        needValue.mediaType = editingMediatype[value.t];
                        needValue.productId = $state.params[value.p];
                    }
                });
                return needValue;
            },

            /**
             * [queryModeconfiguration description] 获取配置
             * @param   {[string]}  key  [keyWord description] 关键字
             * @return  {[type]}         [return description]
             */
            queryModeconfiguration: function (key = 'editCenter') {
                let storgeKey = key + '.configuration';
                localStorageService.remove(storgeKey); // 给出默认值
                getModeConfig(key).then((info) => {
                    localStorageService.set(storgeKey, angular.extend(angular.copy(configuration), info.config));
                    let messageKey = key + '.getConfig';
                    messagePublishService.configPublish(messageKey); // 为了解决异步问题
                    // messagePublishService.configPublish('global.getConfig'); // 为了解决异步问题
                }, (error) => {
                    if (error && error.info === 'token失效') {
                        this.queryModeconfiguration(key); // token失效重新掉用
                    } else {
                        localStorageService.set(storgeKey, {}); // 直接设置为空对象
                    }
                });
                // return defer.promise;
            },

            /**
             * [queryModeconfigurationOnly description] 仅从后端获取配置，获取后配置不存储在缓存中，避免同时使用queryModeconfiguration方法导致的问题
             * @param   {[string]}  key  [key description] 模块关键字
             * @return  {[type]}         [return description]
             */
            queryModeconfigurationOnly: function (key) {
                let defer = $q.defer();
                getModeConfig(key).then((info) => {
                    defer.resolve(info.config);
                }, (error) => {
                    if (error && error.info === 'token失效') {
                        this.queryModeconfiguration(key); // token失效重新掉用
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [getModeconfiguration description] 获取配置（若存在异步问题用此方法）
             * @param   {[string]}  key       [key description] 获取具体的配置项 
             * @param   {[string]}  stogeKey  [stogeKey description] 获取存储的分类
             * @return  {[type]}              [return description]
             */
            getModeconfiguration: function (key, stogeKey = 'editCenter') {
                let defer = $q.defer();
                let strogeMark = stogeKey + '.configuration';
                let config = localStorageService.get(strogeMark);
                if (!config) {
                    let messageKey = stogeKey + '.getConfig';
                    messagePublishService.subscribe(messageKey, () => {
                        // messagePublishService.subscribe('global.getConfig', () => {
                        strogeMark = stogeKey + '.configuration';
                        config = localStorageService.get(strogeMark);
                        if (config[key]) {
                            defer.resolve(config[key].value);
                        } else {
                            defer.resolve({});
                        }
                    });
                } else {
                    if (config[key]) {
                        defer.resolve(config[key].value);
                    } else {
                        defer.resolve({});
                    }
                }
                return defer.promise;
            },

            /**
             * [getModeconfigurationDirect description] 获取配置（若确定不存在异步问题可用）
             * @param   {[type]}  key         [key description] 获取具体的配置项 
             * @param   {[type]}  stogeKey    [stogeKey description] 获取存储的分类
             * @return  {[type]}              [return description]
             */
            getModeconfigurationDirect: function (key, stogeKey = 'editCenter') {
                let strogeMark = stogeKey + '.configuration';
                let config = localStorageService.get(strogeMark);
                return config[key].value;
            },

            // 设置消息为已读
            readmessages: function(params) {
                if (!params.msgsocketrelids) {return Promise.reject();}
                Object.assign(params, {
                    method: 'readmessages',
                    serviceid: 'message',
                    isall: false,
                    socketid: $sessionStorage.get('curUserInfo').ID,
                });
                return trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                    var result = data.issuccess === 'true';
                    return result;
                });
            },

            /**
             * [queryunreadmsgbySiteId description]根据站点id获取app签发失败稿件消息数量
             *
             * @param   {[type]}  types   [types description]
             * @param   {[type]}  siteid  [siteid description]
             *
             * @return  {[type]}          [return description]
             */
            queryunreadmsgbySiteId: function(types, siteid) {
                const params = {
                    method: 'queryBySiteId',
                    serviceid: 'message',
                    socketid: $sessionStorage.get('curUserInfo').ID,
                    opertype: types, // 文档类型可见 https://ol6rbl.yuque.com/docs/share/cab74393-1abf-49c8-8d3f-14a860362b83#eJ2El
                    siteId: siteid
                };
                return trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                    return data;
                });
            },
            // 根据部门ID获取当前用户未读消息数量(适用于部门稿库消息)
            queryunreadmsgbyDepartIds: function(ids) {
                if (!ids) {return Promise.reject();}
                const params = {
                    method: 'queryunreadmsgbyDepartIds',
                    serviceid: 'message',
                    socketid: $sessionStorage.get('curUserInfo').ID,
                    departIds: ids
                };
                return trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                    var unreadmsg = {};
                    data.data.forEach(function(d) {
                        unreadmsg[d.departId] = d.unreadmsg > 999 ? '999+' : d.unreadmsg;
                    });
                    return unreadmsg;
                });
            },
            
            /* [readmessagesByChannelId description]根据栏目id设置消息已读
             *
             * @param   {[type]}  param  [params description]
             *
             * @return  {[type]}          [return description]
             */
            readmessagesByChannelId: function (param) {
                if (!param.CHANNELID) {return Promise.reject();}
                const params = {
                    method: 'readmessagesByChannelId',
                    channelId: param.CHANNELID,
                    opertype: param.OPERTYPE,
                    siteId: param.SITEID,
                    serviceid: 'message',
                    socketid: $sessionStorage.get('curUserInfo').ID
                };
                return trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                    return data.issuccess === 'true';
                });
            },

            /**
             * [getModeconfigurationDirect description] 获取配置（若确定不存在异步问题可用）
             * @param   {[type]}  $scope         [key description] 传过来的scope
             * @return  {[type]}              [return description]
             */
            getHeaderInfo: function ($scope) {
                this.getModeconfiguration('headerInfo', 'commonInfo').then((res) => {
                    $scope.data.headInfo = JSON.stringify(res) !== '{}' ? res : {};
                    $scope.data.headInfo.adminName = $scope.data.headInfo.adminName && !$('.indexTitle').html() ? $scope.data.headInfo.adminName : ($('.indexTitle').html() ? $('.indexTitle').html() : '拓尔思融媒体系统');
                    $scope.data.headInfo.msgCenter = $scope.data.headInfo.msgCenter ? $scope.data.headInfo.msgCenter : false;
                    // $scope.data.headInfo.chatTipBar = $scope.data.headInfo.chatTipBar ? $scope.data.headInfo.chatTipBar : false;
                    document.title = $scope.data.headInfo.adminName;
                    var metaList = document.getElementsByTagName('meta');
                    var modifyArr = ['description', 'keywords', 'author'];
                    for (var i = 0; i < metaList.length; i++) {
                        if (modifyArr.includes(metaList[i].getAttribute('name'))) {
                            metaList[i].content = $scope.data.headInfo.adminName;
                        }
                    }
                });
                this.getModeconfiguration('IM').then((config) => {
                    $scope.data.headInfo.chatTipBar = (config.switch ? config.switch === 'off' : false);
                });
            },

            /**
             * [xssBlackList description] xss标签过滤黑名单
             * @return  {[type]}  [return description]
             */
            xssBlackList: function(){
                let blackList = ['script', 'body', 'iframe', 'frame', 'input', 'link', 'meta', 'xss', 'style', 'base'].concat(Object.keys(window.filterXSS.getDefaultWhiteList()));
                return blackList;
            }
        };
    },
]);
